import { computed, onMounted, ref } from 'vue';
import SalesTransactionsAPI from 'dashboard/api/salesTransactions';

export function useSalesRegistration({ id, t, notify }) {
  const transaction = ref(null);
  const loading = ref(false);
  const error = ref('');
  const isForbidden = computed(
    () => transaction.value?.permissions?.can_save_draft === false
  );

  const load = async () => {
    if (!id.value) return null;

    loading.value = true;
    error.value = '';
    try {
      const response = await SalesTransactionsAPI.show(id.value);
      transaction.value = response?.data || null;
      return transaction.value;
    } catch (requestError) {
      error.value =
        requestError?.response?.data?.message ||
        requestError?.response?.data?.error ||
        t('SALES.REGISTRATION.LOAD_ERROR');
      notify(error.value);
      return null;
    } finally {
      loading.value = false;
    }
  };

  onMounted(load);

  return { error, isForbidden, load, loading, transaction };
}
